import { render } from "./AppArrow.vue?vue&type=template&id=4f5b6446"
import script from "./AppArrow.vue?vue&type=script&lang=js"
export * from "./AppArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__